/**
 * Employee statuses exactly as the backend enum spells them (case-sensitive:
 * a wrong spelling is a 400 on save and a 500 on the list filter).
 */
export const EMPLOYEE_STATUSES = [
  "Active",
  "Probation",
  "Incomplete",
  "Validated",
  "Notice period",
  "Resigned",
  "Terminated",
  "Deceased",
  "Awol",
];
